/**
 * Common messages - English (US)
 * 公共文案 - 美式英语
 */
export default {
  // Actions
  confirm: 'Confirm',
  cancel: 'Cancel',
  save: 'Save',
  submit: 'Submit',
  delete: 'Delete',
  edit: 'Edit',
  add: 'Add',
  search: 'Search',
  reset: 'Reset',
  collapse: 'Collapse',
  expand: 'Expand',
  clearFilter: 'Clear filter',
  startDate: 'Start date',
  endDate: 'End date',
  placeholderSelectQuarter: 'Select quarter',
  yearUnit: '',
  quarterUnit: 'Q',
  quarter1: 'Q1',
  quarter2: 'Q2',
  quarter3: 'Q3',
  quarter4: 'Q4',
  prevYear: 'Previous year',
  nextYear: 'Next year',
  yearQuarterFormat: '{year} Q{quarter}',
  thisWeek: 'This week',
  thisMonth: 'This month',
  lastWeek: 'Last week',
  lastMonth: 'Last month',
  pleaseFillRequired: 'Please fill in required fields.',
  requiredField: 'This field is required',
  placeholderAgentArea: 'Select agent region',
  export: 'Export',
  import: 'Import',
  back: 'Back',
  close: 'Close',
  view: 'View',
  more: 'More',
  copy: 'Copy',
  copySuccess: 'Copied',
  unbound: 'Unbound',
  normal: 'Normal',
  disabled: 'Disabled',
  pin: 'Pinned',
  primary: 'Primary',
  bindMobileTip: 'After binding your phone, you can use it to log in and recover your password.',
  accountPendingConfirmTip: 'After account creation, the status is "Pending confirmation" and the account cannot log in. The employee will receive a DingTalk invitation. After downloading DingTalk and accepting the invitation, the account status will change to "Normal" and login will be available.',
  planningDept: 'Planning Dept',
  classHours: 'credit hours',
  classHoursFormat: '{hours} credit hours',
  selectPayTimeRequired: 'Please select payment time',
  confirmRemoveFile: 'Confirm remove {fileName}?',
  consider: 'Cancel',
  pay: 'Pay',
  payment: 'Payment',

  // Status / tips
  loading: 'Loading...',
  success: 'Success',
  failed: 'Failed',
  noData: 'No Data',
  operationSuccess: 'Operation succeeded',
  operationFailed: 'Operation failed',
  cancelSuccess: 'Cancelled successfully',
  cancelFailed: 'Cancel failed',
  cancelDelete: 'Cancel deleted',
  deleteSuccess: 'Deleted successfully',
  systemErrorRetryLater: 'System error, please try again later',

  // Form
  pleaseInput: 'Please enter',
  pleaseSelect: 'Please select',
  placeholderFilterKeyword: 'Enter keyword to filter',
  placeholderSelectUser: 'Select user',
  selectAll: 'All',

  // Table
  index: 'No.',
  operation: 'Operation',
  remark: 'Remark',
  fileName: 'File Name',
  fileSize: 'Size',
  fileStatus: 'File Status',
  operator: 'Operator',
  operateTime: 'Operate Time',
  createTime: 'Create Time',
  updateTime: 'Update Time',

  // Pagination
  total: 'Total',
  page: 'Page',
  pageSize: 'Page Size',
  goto: 'Go to',
  itemsPerPage: 'items per page',
  switch: 'Switch',
  helpCenter: 'Help Center',
  readDone: 'Marked as read',
  passwordUpdateHint: 'Please update your password for account security',
  oldPasswordLabel: 'Old password:',
  placeholderOldPassword: 'Enter old password',
  newPasswordLabel: 'New password:',
  placeholderNewPassword: 'Enter new password',
  confirmPasswordLabel: 'Confirm new password:',
  placeholderConfirmPassword: 'Confirm new password',
  rulePasswordMismatch: 'New passwords do not match',
  ruleReenterNewPassword: 'Please re-enter new password',
  ruleEnterOldPassword: 'Please enter old password',
  ruleEnterNewPassword: 'Please enter new password',
  ruleReenterNewPasswordForConfirm: 'Please enter new password again',

  loginTitle: 'Agent Management System',
  passwordLogin: 'Password',
  codeLogin: 'Verify Code',
  phoneVerify: 'Phone Verify',
  phoneLabel: 'Phone:',
  placeholderPhone: 'Enter phone',
  changeVerifyPhone: 'Change phone',
  verifyCodeLabel: 'Code:',
  placeholderVerifyCode: 'Enter code',
  getVerifyCode: 'Get Code',
  resendAfter: 's resend',
  resendVerifyCode: 'Resend',
  placeholderUsernameOrPhone: 'Enter username/phone',
  placeholderPassword: 'Enter password',
  forgotPassword: 'Forgot password',
  login: 'Login',
  recoverPassword: 'Recover password',
  recoverPasswordTip: 'Use the phone number bound to your account to recover password',
  verifyCodePlaceholder: 'Code',
  ruleUsernameRequired: 'Please enter username/phone',
  rulePasswordRequired: 'Please enter password',
  ruleValidPhone: 'Please enter a valid phone number',
  ruleVerifyCodeRequired: 'Please enter verification code',
  ruleNewPasswordRequired: 'Please enter new password',
  verifyCodeSuccess: 'Verification code sent',
  verifyCodeFailed: 'Failed to send verification code',
  passwordResetSuccess: 'Password reset. Please log in with the new password.',
  passwordResetFailed: 'Password reset failed',
  confirmClose: 'Confirm close?',
  loginAccountLabel: 'Login account:',
  placeholderLoginAccount: 'Enter login account',
  oldPhoneLabel: 'Old phone:',
  newPhoneLabel: 'New phone:',
  placeholderNewPhone: 'Enter new phone',
  enterOldPhoneRequired: 'Please enter old phone',
  enterNewPhoneRequired: 'Please enter new phone',
  verifyCodeError: 'Invalid verification code',
  phoneVerifyTitle: 'Phone verification',
  resendAfterSend: 's resend',
  prevAgentLevelCycle: 'Prev agent level cycle: ',
  currentAgentLevelCycle: 'Current agent level cycle: ',
  totalPaidOrderAmount: 'Total paid order amount: ',
  yuanUnit: ' CNY',
  unitTai: '',
  bindMobile: 'Bind mobile',
  accountUpgradeMsg: 'Your account has been upgraded to Squirrel AI account. Please log in from the unified login platform.',
  changeVerifyPhoneTitle: 'Change verification phone - Identity verification',
  changePhoneBindTitle: 'Change phone - Bind new phone',
  enterPhoneRequired: 'Please enter phone number',
  verifyCodeSentSuccess: 'Verification code sent. Please check your phone.',
  enterVerifyCodeRequired: 'Please enter verification code',
  loginFailed: 'Login failed',
  verifySuccess: 'Verification success',
  nextStep: 'Next',

  // Home / layout
  accountSecurityCenter: 'Account Security Center',
  exportDownload: 'Export & Download',
  closeSystem: 'Close System',
  modifyPassword: 'Change Password',
  logout: 'Log out',
  headquarterNotice: 'Headquarter Notice',
  viewDetail: 'View details',
  targetSettingReminder: 'Target Setting Reminder',
  remindMeLater: 'Remind me later',
  goToSet: 'Go to set',
  newAnnouncementTitle: 'You have a new announcement',
  emergencyTag: '[Urgent]',
  viewLater: 'View later',
  viewNow: 'View now',
  importantTag: '[Important]',
  requestFailed: 'Request failed',
  verifyFailed: 'Verification failed!',
  passwordChangeSuccess: 'Password changed. Please log in with the new password.',
  passwordChangeFailed: 'Failed to change password',
  creditOrderPaymentRequirement: 'Credit order payment requirement',
  creditOrderTailPaymentDesc: 'After dealer sales equipment activation payment, the credit order balance needs to be paid. ',
  doubleOrderHelpDesc: 'Double order is a purchase order for provincial agents to centralize inventory with linked agents and dealers. See: ',
  warehousePickupHelpDesc: 'Warehouse pickup is to pick up your JD cloud warehouse stock to offline stores via the agent system. See: ',
  loanReturnHelpDesc: 'Inter-warehouse loan/return allows agents with JD cloud warehouse to loan/return within the same warehouse. See: ',
  agentAccountFaq: 'Agent account FAQ: ',
  referralAndChannel: 'Referral & channel',
  creditOrder: 'Credit order',
  creditOrderHelpIntro: 'To help dealers grow quickly',
  orderRequirementTitle: 'Order requirement',
  creditOrderRequirementDesc: 'Dealers can submit credit orders to upstream agents',
  orderProcessTitle: 'Order process',
  orderProcessDesc1: 'Order takes effect after agent approval',
  orderProcessDesc2: 'After agent ships, SN is transferred to the dealer',
  systemUsageRestricted: 'Your system access has been restricted. Reason: ',
  restrictionReason: 'Restriction reason',
  helpCardReferralReward: 'For referral first payment reward rules and queries, see Help Center.',
  helpCardRegionCustomers: 'For regional referral customer queries, see Help Center.',
  helpCardRebatesFees: 'For channel rebates and service fee rules and queries, see Help Center.',

  // AdvertiseMessage
  setEmergencyContact: 'Set emergency contact',
  emergencyContactSetting: 'Emergency Contact Settings',
  emergencyContactTip1: 'To avoid missing urgent and important notifications from headquarters (such as core policies), the system recommends setting up to 2 emergency contacts for your organization to receive such notifications and communicate them internally.',
  emergencyContactTip2: 'Note: Accounts set as "Emergency Contacts" will receive notifications via phone calls and messages in rare cases (generally no more than 3 times a month). Please remind the designated personnel to pay attention to incoming calls.',
  selectStaff: 'Select Staff',
  placeholderSelectStaff: 'Please select staff',
  emergencyContact1: 'Emergency Contact 1',
  emergencyContact2: 'Emergency Contact 2',
  notSet: 'Not Set',
  emergencyContactDescription: 'Do not need to set emergency contacts? Click the button on the right to disable reminders',
  submitSuccess: 'Submitted successfully',
  submitFailed: 'Submission failed',
  getEmergencyContactFailed: 'Failed to get emergency contact list',
  // Common table columns
  sequence: 'No.',
  name: 'Name',
  phoneNumber: 'Phone',
  dingTalkNumber: 'DingTalk ID',
  viewDetail: 'View detail',
  downloadAttachment: 'Download attachment',
  objectionContent: 'Objection content',
  viewObjectionTitle: 'View objection',
  objectionLabel: 'Objection:',
  placeholderObjection: 'Please fill in your opinion about the notice',
  noAttachment: 'No attachment for this notice',
  noticeTitle: 'Notice title',
  placeholderNoticeTitle: 'Enter notice title',
  noticeType: 'Notice type',
  placeholderNoticeType: 'Select notice type',
  urgencyLevel: 'Urgency',
  placeholderUrgency: 'Select urgency',
  noticeStatus: 'Status',
  placeholderNoticeStatus: 'Select status',
  sendTimeLabel: 'Send time:',
  noticeTitleCol: 'Notice title',
  noticeTypeNameCol: 'Notice type',
  urgencyLevelNameCol: 'Urgency',
  readStatusNameCol: 'Status',
  sendTimeCol: 'Send time',
  readTimeCol: 'Read time',
  download: 'Download',
  rangeTo: 'To',

  // Export component
  exportTip: 'Tip',
  exportSubmitSuccess: 'Export task submitted successfully',
  exportGoToPrefix: 'Go to ',
  exportGoToSuffix: ' to download',
  importExport: 'Import & Export',
  notNow: 'Not now',
  goToExportDownload: 'Go to export download',
  exportApiRequired: 'Please provide API URL',
  refreshStatus: 'Refresh status',
  confirmDeleteFile: 'Confirm delete {fileName}?',
  downloadFailed: 'Download failed',
  exportFailed: 'Export failed',
  systemErrorContactAdmin: 'System error, please contact administrator',
  fetchDataFailed: 'Failed to fetch data',

  // Account freeze / wake-up (WakeDialog)
  wakeFreezeIntro: 'Your Songshu Ai account has been frozen due to security risk from extended inactivity. To continue, you can wake up your account.',
  wakeNotLoginNow: 'Not now',
  wakeActivateNow: 'Wake up now',
  wakeSecondIntro: 'The Songshu Ai account under ID {campusId} is being woken up. In DingTalk for {phone}, accept the headquarters team invitation to join.',
  wakeDefer: 'Later',
  wakeConfirmed: 'Done',
  wakeAccountDisabled: 'Your account has been disabled. Please contact your supervisor.',
  wakeSuccess: 'Account woken up successfully',
  wakeFailedRetry: 'Wake-up failed. Please try again later.',
};
